module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/RADIOGRAPHY-MEDICAL TECHNOLOGY-23f3934f4490d7a4cc6d4a5cdb3739e9.png";